import { render, staticRenderFns } from "./CriminalFilesList.vue?vue&type=template&id=d88d1304&"
import script from "./CriminalFilesList.vue?vue&type=script&lang=js&"
export * from "./CriminalFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports